module.exports = __webpack_public_path__ + "static/img/14.7b101c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/14.png
// module id = /sdK
// module chunks = 0